"use strict";

var _slicedToArray = require("/home/circleci/project/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var useWindowHeight = function useWindowHeight() {
  var _ref = (0, _react.useState)(typeof window !== 'undefined' ? window.innerHeight : 0),
      _ref2 = _slicedToArray(_ref, 2),
      windowHeight = _ref2[0],
      setWindowHeight = _ref2[1];

  var handleResize = function handleResize() {
    return setWindowHeight(window.innerHeight);
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      setWindowHeight(window.innerHeight);
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);
  return windowHeight;
};

var _default = useWindowHeight;
exports.default = _default;